import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Download, Copy } from "lucide-react";
import { toast } from "sonner";

const QRModal = ({ open, onClose, slug, name }) => {
  const wrapRef = useRef(null);
  const url = `${window.location.origin}/m/${slug}`;

  const download = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr-${slug}.png`;
    a.click();
    toast.success("QR scaricato");
  };

  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link copiato"); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="qr-modal">
        <DialogHeader><DialogTitle>QR del menù · {name}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground -mt-2">Stampalo sul Cubetto: chi lo inquadra apre subito questo menù.</p>
        <div ref={wrapRef} className="flex justify-center py-4">
          <div className="p-4 bg-white rounded-2xl border border-border">
            <QRCodeCanvas value={url} size={220} level="H" includeMargin marginSize={2} />
          </div>
        </div>
        <p className="text-center text-xs text-muted-foreground break-all">{url}</p>
        <div className="flex gap-2 mt-3">
          <button onClick={download} data-testid="qr-download-btn" className="flex-1 rounded-full bg-[#002FA7] text-white px-4 py-2.5 text-sm font-semibold hover:bg-[#00248a] flex items-center justify-center gap-2"><Download className="w-4 h-4" /> Scarica PNG</button>
          <button onClick={copy} className="rounded-full border border-border px-4 py-2.5 text-sm font-medium hover:bg-muted flex items-center gap-2"><Copy className="w-4 h-4" /> Link</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QRModal;
